module.exports = __webpack_public_path__ + "static/media/banner_mobile.77f82309.jpg";